module.exports = __webpack_public_path__ + "assets/img/xpzy.76b001f5.png";